import React, { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { fmtIDR, fmtNum, FUEL_META } from "@/lib/format";
import { Download, TrendingUp, TrendingDown } from "lucide-react";

const BukuStock = () => {
  const [stock, setStock] = useState([]);
  useEffect(() => { api.get("/stock").then(r => setStock(r.data)); }, []);

  const download = () => {
    const token = localStorage.getItem("spbu_token");
    fetch(`${API}/export/buku-stock.xlsx`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.blob()).then(b => {
        const url = URL.createObjectURL(b);
        const a = document.createElement("a"); a.href = url; a.download = "buku_stock.xlsx"; a.click();
      });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Buku Stock BBM</h1>
          <p className="text-sm text-slate-500 mt-1">Kartu stock real-time per jenis BBM</p>
        </div>
        <Button data-testid="export-excel-button" onClick={download} className="bg-[#005DAA] hover:bg-[#004885]">
          <Download className="w-4 h-4 mr-2" /> Export Excel
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {stock.map(s => {
          const m = FUEL_META[s.code];
          const margin = s.sell_price - s.buy_price;
          return (
            <Card key={s.code} className={`${m.border} border-2`}>
              <CardHeader className="pb-2">
                <div className="flex items-center gap-2">
                  <div className={`w-3 h-3 rounded-full ${m.dot}`} />
                  <CardTitle className={`text-base font-bold ${m.text}`}>{m.name}</CardTitle>
                </div>
              </CardHeader>
              <CardContent className="space-y-3">
                <div>
                  <div className="text-xs uppercase text-slate-500 font-semibold">Stock Tersedia</div>
                  <div className="text-3xl font-extrabold font-mono-fig text-slate-900">{fmtNum(s.stock_liters, 0)} L</div>
                </div>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div className="rounded bg-slate-50 p-2">
                    <div className="text-xs text-slate-500">Harga Beli</div>
                    <div className="font-bold font-mono-fig">{fmtIDR(s.buy_price)}</div>
                  </div>
                  <div className="rounded bg-slate-50 p-2">
                    <div className="text-xs text-slate-500">Harga Jual</div>
                    <div className="font-bold font-mono-fig">{fmtIDR(s.sell_price)}</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 pt-2 border-t border-slate-100">
                  <Badge className="bg-emerald-50 text-emerald-700 border border-emerald-200">
                    Margin {fmtIDR(margin)}/L
                  </Badge>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="border-slate-200">
        <CardHeader><CardTitle className="text-lg font-bold">Ringkasan Mutasi Stock</CardTitle></CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>BBM</TableHead>
                <TableHead className="text-right">Pembelian (L)</TableHead>
                <TableHead className="text-right">Penjualan (L)</TableHead>
                <TableHead className="text-right">Stock Akhir (L)</TableHead>
                <TableHead className="text-right">Nilai Stock (HPP)</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {stock.map(s => {
                const m = FUEL_META[s.code];
                return (
                  <TableRow key={s.code}>
                    <TableCell>
                      <div className="flex items-center gap-2">
                        <div className={`w-2 h-2 rounded-full ${m.dot}`} />
                        <span className="font-semibold">{m.name}</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-right font-mono-fig text-emerald-700">
                      <TrendingUp className="inline w-3 h-3 mr-1" />{fmtNum(s.purchased_liters)}
                    </TableCell>
                    <TableCell className="text-right font-mono-fig text-rose-700">
                      <TrendingDown className="inline w-3 h-3 mr-1" />{fmtNum(s.sold_liters)}
                    </TableCell>
                    <TableCell className="text-right font-mono-fig font-bold">{fmtNum(s.stock_liters)}</TableCell>
                    <TableCell className="text-right font-mono-fig">{fmtIDR(s.stock_value)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default BukuStock;
